/**
 * Returns information about the current logged in user from cookies.
 * @return {UserFeatures}
 */
import { cookies, IS_CLIENT } from '../constants';
import getCookie from '../getCookie';
export const getUserFeatures = () => {
    var _a;
    const userFeatures = {};
    const userCookie = JSON.parse(`${getCookie(cookies.USER_COOKIE_NAME)}`);
    const utagMainCookie = getCookie(cookies.UTAG_MAIN_COOKIE_NAME);
    const aemSegsCookie = getCookie(cookies.AEM_SEGS_COOKIE_NAME);
    const aamGaSegsCookie = getCookie(cookies.AAM_GA_SEGS_COOKIE_NAME);
    const cpSegsCookie = getCookie(cookies.CP_SEGS_COOKIE_NAME);
    if (userCookie) {
        userFeatures.customerClubLevel = userCookie.customer_club_level;
        userFeatures.customerState = userCookie.st;
        userFeatures.customerClubMember = (_a = userCookie.customerGroup) === null || _a === void 0 ? void 0 : _a.includes('loyaltyMemberGroup');
        userFeatures.bpid = userCookie.bpid;
    }
    if (utagMainCookie) {
        userFeatures.utagMainCartActive = utagMainCookie.indexOf('cart_active:Yes') >= 0;
        userFeatures.utagMainCustomerHasFavourites = utagMainCookie.indexOf('c_favourites:Yes') >= 0;
        const cartNrItemsMatches = utagMainCookie.match('cart_nritems:([0-9]*)');
        if (cartNrItemsMatches && Array.isArray(cartNrItemsMatches)) {
            const [, cartNrItems] = cartNrItemsMatches;
            const parsedCartNrItems = Number.parseInt(cartNrItems, 10);
            if (!Number.isNaN(parsedCartNrItems)) {
                userFeatures.utagMainCartNrItems = parsedCartNrItems;
            }
        }
    }
    if (aemSegsCookie) {
        userFeatures.aemsegs = aemSegsCookie
            .replace('aem%3D', '')
            .replace('%2Caam%3D', '%3B')
            .split('%3B');
    }
    if (aamGaSegsCookie) {
        userFeatures.aamgasegs = aamGaSegsCookie.replace('segid%3D', '').split('%3B');
    }
    if (cpSegsCookie) {
        userFeatures.cpsegs = cpSegsCookie.replace('cpsegs%3D', '').split('%3B');
    }
    if (IS_CLIENT) {
        userFeatures.url = window.location.href;
        if (window.utag_data) {
            userFeatures.clientIdGa = window.utag_data.client_id_ga;
            userFeatures.customerBpidOutput = window.utag_data.customer_bpid_output;
            userFeatures.touchpoint = window.utag_data.touchpoint;
            userFeatures.customerCity = window.utag_data.customer_city;
            userFeatures.selectedMarket = window.utag_data.selected_market;
            userFeatures.customerFashionNews = window.utag_data.customer_fashion_news;
            userFeatures.customerHasChildren = window.utag_data.customer_has_children;
            userFeatures.cartActiveOutput = window.utag_data.cart_active_output;
        }
    }
    return userFeatures;
};
export default getUserFeatures;
//# sourceMappingURL=getUserFeatures.js.map